const AddListsIntoPage = (page, lists) => {

    let returnPage = {...page};

    for (const column of returnPage.Columns) {
        for (const formGroup of column.FormGroups) {
            for (const field of formGroup.Fields) {
                if (field.OptionsName !== undefined && field.OptionsName !== "" && ! field.Dynamic) {
                    if (field.ParentList === undefined || field.ParentList === "") {
                        const list = lists.filter(l => l.Name.toLowerCase() === field.OptionsName.toLowerCase());
                        field.Options = list[0].Options.map((option) => { return {key: option.Key, text: option.Text, ParentKey: option.ParentKey}});
                        // field.Resettable = true;
                    }
                } 
                if (field.Type === "fieldgrid" && field.GridFields !== undefined) {
                    for (const gridField of field.GridFields) {
                        if (gridField.Type === "dropdown" || gridField.Type === "filteredcombo"  || gridField.Type == "combobox") {
                            const list = lists.filter(l => l.Name.toLowerCase() === gridField.OptionsName.toLowerCase());
                            gridField.Options = list[0].Options.map((option) => { return {key: option.Key, text: option.Text, ParentKey: option.ParentKey}});
                            // gridField.Resettable = true;
                        }
                    }
                }
            }
        }
    }

    return returnPage;
}

export default AddListsIntoPage;